export default __webpack_public_path__ + "static/media/empty-data-3.0284472b.svg";